import { useEffect } from 'react';
import './styles/reset.css';
import './App.css';
import './styles/grid.css';
import './styles/light-theme.css';
import './styles/dark-theme.css';
import './styles/ui-foundation.css';

import AppRoutes from './pages/AppRoutes';
import { ThemeProvider } from './ThemeContext';
import ConnectivityStatus from './components/ConnectivityStatus';
import { usePreventZoom } from './hooks/usePreventZoom';
import { FeedbackProvider } from './FeedbackContext';
import { initializeNaraAppCheck } from './services/appCheck';
import { FinancialPrivacyProvider } from './FinancialPrivacyContext';

function App() {
  usePreventZoom();
  useEffect(() => { initializeNaraAppCheck(); }, []);

  return (
    <ThemeProvider>
      <FinancialPrivacyProvider>
        <FeedbackProvider>
          <ConnectivityStatus />
          <AppRoutes />
        </FeedbackProvider>
      </FinancialPrivacyProvider>
    </ThemeProvider>
  );
}

export default App;